import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import axios from "axios";
import VueAxios from "vue-axios";

const Discord = require("discord.js");
const client = new Discord.Client();

client.once("ready", () => {
  console.log("Discord Ready!");
});

createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(router)
  .use(VueAxios, axios)
  .mount("#app");
